import { useAuth } from '../hooks/auth.hooks';
import type { LoginData } from '../hooks/auth.hooks';
import labitatLogo from '../assets/labitat_logo_m.png';

import {
  Button,
  Image,
  Divider,
  Group,
  Paper,
  PaperProps,
  PasswordInput,
  Stack,
  Text,
  TextInput,
  Center,
  Container,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { GoogleButton } from '../components/GoogleButton';

import styles from './login.module.css';

export function Login(props: PaperProps) {
  const { login, loginWithGoogle, isAuthenticated } = useAuth();

  const form = useForm<LoginData>({
    initialValues: {
      email: '',
      password: '',
    },
    validate: {
      email: (val) => (/^\S+@\S+$/.test(val) ? null : 'כתובת המייל אינה תקינה'),
    },
  });

  const handleSubmit = (values: LoginData) => {
    login.mutate(values);
  };

  return (
    <Container>
      <Center className={styles['login-card']}>
        <Paper
          className={styles['login-paper']}
          radius="md"
          shadow="md"
          p="xl"
          withBorder
          {...props}
        >
          <img
            src={labitatLogo}
            alt="Labitat Logo"
            width="100px"
            className={styles.logo}
          />
          <Text size="lg" fw={500}>
            ברוך הבא למערכת
          </Text>

          <Group grow mb="md" mt="md">
            <GoogleButton
              radius="xl"
              onClick={() => loginWithGoogle.mutate()}
              disabled={isAuthenticated}
            >
              Google{' '}
            </GoogleButton>
          </Group>

          <Divider
            label="או המשך עם כתובת מייל"
            labelPosition="center"
            my="lg"
          />

          <form onSubmit={form.onSubmit(handleSubmit)}>
            <Stack>
              <TextInput
                required
                label="אימייל"
                placeholder="myemail@gmail.com"
                value={form.values.email}
                onChange={(event) =>
                  form.setFieldValue('email', event.currentTarget.value)
                }
                error={form.errors.email}
                radius="md"
                styles={{
                  wrapper: { direction: 'ltr' },
                  input: { textAlign: 'left' },
                }}
              />

              <PasswordInput
                required
                label="סיסמה"
                placeholder="הסיסמה שלך"
                value={form.values.password}
                onChange={(event) =>
                  form.setFieldValue('password', event.currentTarget.value)
                }
                error={form.errors.password}
                radius="md"
                styles={{
                  wrapper: { direction: 'ltr' },
                  input: { textAlign: 'left' },
                  innerInput: {
                    direction: form.values.password ? 'ltr' : 'rtl',
                    textAlign: form.values.password ? 'left' : 'right',
                  },
                  visibilityToggle: {
                    display: form.values.password ? 'initial' : 'none',
                  },
                }}
              />
              <Text fw={700} c="red" ta="right" size="12px" h="16px">
                {login.error ? 'שם משתמש או סיסמה שגויים' : ''}
              </Text>
            </Stack>

            <Group justify="space-between" mt="xl">
              <Button
                type="submit"
                radius="xl"
                loading={login.isPending}
                disabled={isAuthenticated}
              >
                כניסה
              </Button>
            </Group>
          </form>
        </Paper>
      </Center>
    </Container>
  );
}
